import React from "react";
import PropTypes from "prop-types";
import { Button, Drawer } from "antd";
import styled, { createGlobalStyle } from "styled-components";
import { spacing } from "../../theme/tokens";

/**
 * Create Task / Create Work Item from an open document.
 *
 * The old centered overlay covered the page (and ate its scroll), so
 * you could not keep reading the letter while writing the note.
 * This is a right-hand panel with no dimmer: the document stays
 * scrollable and clickable while the form is open. Close with the
 * X, Cancel, or Escape — clicking the document does not dismiss it.
 */

export const BESIDE_DOC_DRAWER_CLASS = "whg-beside-doc-drawer";

export const BesideDocumentDrawerStyles = createGlobalStyle`
  .${BESIDE_DOC_DRAWER_CLASS} {
    pointer-events: none;
  }
  .${BESIDE_DOC_DRAWER_CLASS} .ant-drawer-content-wrapper {
    pointer-events: auto;
  }
`;

export const DrawerFooterRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${spacing[2]};
`;

export const besideDocumentDrawerProps = {
  placement: "right",
  width: "min(420px, 100vw)",
  mask: false,
  keyboard: true,
  push: false,
  destroyOnClose: true,
  rootClassName: BESIDE_DOC_DRAWER_CLASS,
  rootStyle: { pointerEvents: "none" },
  styles: {
    wrapper: { pointerEvents: "auto" },
  },
};

const BesideDocumentDrawer = ({
  open,
  onClose,
  title,
  okText,
  onOk,
  okDisabled,
  okLoading,
  hideOk = false,
  cancelText = "Cancel",
  children,
}) => (
  <>
    <BesideDocumentDrawerStyles />
    <Drawer
      {...besideDocumentDrawerProps}
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <DrawerFooterRow data-testid="beside-document-drawer">
          <Button onClick={onClose}>{cancelText}</Button>
          {!hideOk && (
            <Button
              type="primary"
              onClick={onOk}
              disabled={okDisabled}
              loading={okLoading}
            >
              {okText}
            </Button>
          )}
        </DrawerFooterRow>
      }
    >
      {children}
    </Drawer>
  </>
);

BesideDocumentDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node,
  okText: PropTypes.string,
  onOk: PropTypes.func,
  okDisabled: PropTypes.bool,
  okLoading: PropTypes.bool,
  hideOk: PropTypes.bool,
  cancelText: PropTypes.string,
  children: PropTypes.node,
};

export default BesideDocumentDrawer;
